function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M13.4008 12.1152H8.23907C7.90832 12.1152 7.63989 12.3808 7.63989 12.7081C7.63989 13.0353 7.90832 13.3009 8.23907 13.3009H13.4008C13.7315 13.3009 13.9999 13.0353 13.9999 12.7081C13.9999 12.3808 13.7315 12.1152 13.4008 12.1152Z",
  fill: "#0041BE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7907 6.76642L4.87409 12.6125C4.46905 13.0125 3.9202 13.2386 3.34819 13.2386H0.557632C0.409037 13.2386 0.267631 13.1785 0.155785 13.0757C0.0519285 12.9659 0 12.8259 0 12.6718L0.0742977 9.89261C0.0822867 9.34168 0.31237 8.81998 0.706227 8.42951L6.59252 2.60553C6.68999 2.50909 6.84817 2.50909 6.94643 2.60553L10.7907 6.41704C10.889 6.51347 10.8882 6.66998 10.7907 6.76642Z",
  fill: "#0041BE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M12.8684 4.68387L12.0639 5.48695C11.9433 5.6071 11.7467 5.60789 11.6253 5.48775L7.87286 1.77504C7.75222 1.65568 7.75143 1.46202 7.87206 1.34188L8.66776 0.547483C9.39796 -0.180514 10.5867 -0.182885 11.3201 0.54274L12.8636 2.06987C13.5922 2.79076 13.5946 3.95982 12.8684 4.68387Z",
  fill: "#0041BE"
});

function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8177c8a2.svg";
export { ForwardRef as ReactComponent };